<template>
    <div :class="['contacts-sidebar', { 'mobile-hidden': !showContacts && isMobile }]">
        <div class="contacts-header">
            <h1>{{ $t("messages") }}</h1>
            
            <div class="filter-toggle">
                <button 
                    :class="['toggle-btn', { 'active': filterMode === 'active' }]"
                    @click="setFilterMode('active')"
                >
                    <i class="mdi mdi-message-text"></i>
                    <span>{{ $t("messenger.active") || "Active" }}</span>
                </button>
                <button 
                    :class="['toggle-btn', { 'active': filterMode === 'archived' }]"
                    @click="setFilterMode('archived')"
                >
                    <i class="mdi mdi-archive"></i>
                    <span>{{ $t("messenger.archived") || "Archived" }}</span>
                </button>
            </div>
        </div>

        <div class="contacts-list">
            <ContactItem v-for="contact in contacts" :key="`${contact.id}-${contact.offer.id}`" :contact="contact"
                :is-active="isContactActive(contact)" @click="$emit('select-contact', contact)">

            </ContactItem>
        </div>
    </div>
</template>

<script>
import ContactItem from "@/components/messenger/ContactItem.vue";

export default {
    name: "ContactsSidebar",
    components: {
        ContactItem
    },
    props: {
        contacts: {
            type: Array,
            required: true
        },
        selectedContact: {
            type: Object,
            default: null
        },
        showContacts: {
            type: Boolean,
            required: true
        },
        isMobile: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            filterMode: 'active' // 'active' or 'archived'
        };
    },
    methods: {
        isContactActive(contact) {
            return this.selectedContact&&
                this.selectedContact.id===contact.id&&
                this.selectedContact.offer.id===contact.offer.id;
        },
        setFilterMode(mode) {
            this.filterMode = mode;
            this.$emit('filter-change', mode);
        }
    }
};
</script>

<style scoped>
.contacts-sidebar {
    width: 380px;
    display: flex;
    flex-direction: column;
    border-right: 1px solid var(--gray-200);
    background: white;
}

.contacts-header {
    padding: 16px;
    border-bottom: 1px solid var(--gray-200);
}

.contacts-header h1 {
    margin: 0 0 12px 0;
    font-size: 20px;
    font-weight: 600;
    color: var(--gray-900);
}

.filter-toggle {
    display: flex;
    gap: 8px;
    background: var(--gray-100);
    padding: 4px;
    border-radius: 8px;
}

.toggle-btn {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 8px 12px;
    border: none;
    background: transparent;
    color: var(--gray-600);
    font-size: 13px;
    font-weight: 500;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.2s ease;
}

.toggle-btn i {
    font-size: 16px;
}

.toggle-btn:hover {
    background: var(--gray-200);
    color: var(--gray-800);
}

.toggle-btn.active {
    background: white;
    color: var(--color-nz);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.contacts-list {
    flex: 1;
    overflow-y: auto;
}

@media (max-width: 767px) {
    .contacts-sidebar {
        width: 100%;
    }

    .mobile-hidden {
        display: none !important;
    }
    
    .toggle-btn span {
        display: none;
    }
    
    .toggle-btn {
        padding: 8px;
    }
}
</style>